/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {buildUserOp} from '../api'

export const useMutationBuildUserOp = createReactQueryMutationHook('buildUserOp', buildUserOp)
